import { buildErrorMessage } from "./apiUtils";

class ApiTags {
  public static async getTags(signal?: AbortSignal) {
    const response = await fetch("/api/v1/tags", {
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      signal,
    });

    if (!response.ok) {
      const errorMessage = await buildErrorMessage(
        response,
        "Failed to fetch tags"
      );
      throw new Error(errorMessage);
    }

    return response.json();
  }

  public static async createTag(label: string, color?: string, signal?: AbortSignal) {
    const response = await fetch("/api/v1/tags", {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ label, color }),
      signal,
    });

    if (!response.ok) {
      const errorMessage = await buildErrorMessage(
        response,
        "Failed to create tag"
      );
      throw new Error(errorMessage);
    }

    return response.json();
  }

  public static async updateTag(
    id: number,
    updates: { label?: string; color?: string },
    signal?: AbortSignal
  ) {
    const response = await fetch(`/api/v1/tags/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updates),
      signal,
    });

    if (!response.ok) {
      const errorMessage = await buildErrorMessage(
        response,
        "Failed to update tag"
      );
      throw new Error(errorMessage);
    }

    return response.json();
  }

  public static async deleteTag(id: number, signal?: AbortSignal) {
    const response = await fetch(`/api/v1/tags/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      signal,
    });

    if (!response.ok) {
      const errorMessage = await buildErrorMessage(
        response,
        "Failed to delete tag"
      );
      throw new Error(errorMessage);
    }

    return response.json();
  }
}

export default ApiTags;

